<template>
    <modal
          name="cups"
          width="90%"
          height="auto"
          :adaptive="true"
          scrollable
          class="roundedmodal"
        >
          <div>
            <div class="mt-3 flex justify-end pr-3">
              <a @click.prevent="$modal.hide('cups')">
                <IconCancel
                    :fill="btnDestructiveIcon"
                    :stroke="btnDestructiveIcon"
                />
              </a>
            </div>
            <p class="mt-4 text-center text-lg">
              {{ menu[`cups_instruction_${language}`] }}
            </p>
            <div class="w-full flex py-4 justify-center">
              <div
                :class="[
                  'cursor-pointer w-full flex border-b-2  mx-4 pb- pl-4 transition duration-500 items-center justify-between rounded-t-lg',
                  'flex-row lg:w-2/3 pb-2 mb-2',
                ]"
              >
                <!-- left side product -->
                <div :class="['flex', 'flex-row w-2/3 ']">
                  <div
                    :class="[
                      'flex-none flex items-center overflow-hidden rounded-lg justify-center',
                      cupsItem.pictureUrl && menu.product_images_enabled && selectedMenuCategory.enable_product_images
                        ? 'block'
                        : 'hidden',
                      'w-20 h-20',
                    ]"
                  >
                    <Picture
                      v-if="cupsItem.pictureUrl"
                      :src="cupsItem.pictureUrl"
                      alt
                      :class="['object-cover  h-full md:w-full']"
                    />
                  </div>
                  <div
                    :class="[
                      'flex-grow ml-4',
                      orderingEnabled ? '' : 'items-center flex',
                    ]"
                  >
                    <div class="flex-1">
                      <div :class="['font-medium justify-between']">
                        <!-- item name (title)-->
                        <span
                          :class="[
                            'font-semibold text-lg xs:text-sm xs:w-9/12 xs:break-all',
                          ]"
                          v-trans:name="cupsItem"
                          :style="makeStyles(titleMain , hasKiosk&&titleFont,hasKiosk&&titleTextTransform)"
                        ></span>
                      </div>
                      <!-- item price -->
                      <div
                        :class="['text-xs flex text-product-gray mt-1']"
                        v-trans:description="cupsItem"
                      ></div>

                      <!-- class="text-new-primary font-semibold text-sm mt-1 md:flex md:justify-center block md:hidden"
                            :style="listsText" -->
                      <span
                        class="font-semibold text-sm mt-1 block xs:text-xs"
                        :style="text"
                        v-if="cupsItem.price > 0 && orderingEnabled"
                        >{{ currency }}
                        {{
                          (Math.round(cupsItem.price * 100) / 100).toFixed(2)
                        }}
                      </span>

                      <span
                        :class="[
                          'text-new-primary font-semibold text-sm mt-3 hidden',
                          !orderingEnabled ? 'mb-2' : '',
                        ]"
                        :style="listsText"
                        v-if="
                          (cupsItem.price > 0 &&
                            !hasKiosk) ||
                          (menu.is_kiosk_show_prices &&
                            hasKiosk &&
                            cupsItem.price > 0)
                        "
                        >{{ currency }}
                        {{
                          (Math.round(cupsItem.price * 100) / 100).toFixed(2)
                        }}
                      </span>
                    </div>
                  </div>
                </div>
                <!-- right side product -->
                <div
                  v-if="
                    orderingEnabled &&
                    selectedMenuCategory.is_ordering_disabled == false
                  "
                  class="flex items-center mt-2 w-1/3 xs:justify-end"
                >
                  <div
                    v-if="
                      $_.countBy(
                        cartItems,
                        $_.omit(cupsItem, [
                          'upsell_item_available',
                          'upselling_custom_group_name',
                        ])
                      ).true || 0
                    "
                    :class="[
                      'flex items-center rounded-full w-full xs:justify-end',
                    ]"
                  >
                    <!-- buttton when 1 item is in basket -->
                    <div
                      :class="[
                        'flex flex-row rounded-xl border-new-primary relative bg-primary-100 justify-center items-center border-2 w-full mr-4 px-1 xs:mr-0 xs:w-4/5 xs:justify-end',
                        hasKiosk ? 'h-12' : 'h-8',
                      ]"
                      v-if="
                        orderingEnabled &&
                        selectedMenuCategory.is_ordering_disabled == false
                      "
                      :style="
                        btnOutlineActiveBorder + btnOutlineActiveBackground
                      "
                    >
                      <!-- min button -->
                      <div @click="removeFromCart(cupsItem)">
                        <button
                          :class="[
                            'sm:w-10 productClick fill-current focus:outline-none inline-block font-bold  rounded-full flex items-center',
                          ]"
                          :style="hasKiosk&&addButtonRadius"
                          :disabled="disableAddButton"
                        >
                        <IconMinus
                            :stroke="buttonImgColors"
                            :style="btnOutlineIcon"
                        />
                        </button>
                      </div>
                      <div
                        v-if="itemBeingAdded == cupsItem.Id"
                        :class="['spinner-white w-2 flex-1']"
                        style="position: relative !important"
                      >
                        <input
                          type="number"
                          readonly
                          :class="[
                            'focus:outline-none text-center text-new-primary font-bold text-md flex items-center outline-none w-full justify-center bg-primary-100 xs:text-xs',
                            hasKiosk ? 'h-10' : 'h-6',
                          ]"
                          name="custom-input-number"
                          :value="
                            $_.countBy(
                              cartItems,
                              $_.omit(cupsItem, [
                                'upsell_item_available',
                                'upselling_custom_group_name',
                              ])
                            ).true || 0
                          "
                          :style="
                            btnOutlineActiveBackground + btnOutlineActiveText
                          "
                        />
                      </div>
                      <input
                        v-else
                        type="number"
                        readonly
                        :class="[
                          'static focus:outline-none text-center text-new-primary font-bold text-sm sm:text-md  flex items-center outline-none w-full justify-center bg-primary-100 xs:text-xs',
                          hasKiosk ? 'h-10' : 'h-6',
                        ]"
                        name="custom-input-number"
                        :value="
                          $_.countBy(
                            cartItems,
                            $_.omit(cupsItem, [
                              'upsell_item_available',
                              'upselling_custom_group_name',
                            ])
                          ).true || 0
                        "
                        :style="
                          btnOutlineActiveBackground + btnOutlineActiveText
                        "
                      />
                      <!-- plus button -->
                      <div class="">
                        <button
                          @click="addToCart(cupsItem)"
                          :disabled="disableAddButton"
                          :class="[
                            'sm:w-10 productClick font-bold md:w-10 rounded-full cursor-pointer focus:outline-none flex items-center justify-end',
                          ]"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            class="w-5 md:w-10 h-10 xs:w-3 xs:h-3"
                          >
                            <path
                              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                              fill="none"
                              :stroke="buttonImgColors"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    v-else
                    :class="[
                      'w-full justify-center mr-4 text-right xs:mr-0 xs:w-4/5 xs:justify-end',
                    ]"
                    @click="addToCart(cupsItem)"
                  >
                    <!-- button without item selected in cart -->
                    <div
                      v-if="
                        orderingEnabled &&
                        selectedMenuCategory.is_ordering_disabled == false
                      "
                      :class="[
                        'xs:p-0 p-1 rounded-xl items-center justify-end transition duration-500 border-2 w-auto inline-block flex justify-center bg-white',
                        hasKiosk ? 'h-12' : 'h-8',
                      ]"
                      :style="btnOutlineBorder + btnOutlineBackground"
                    >
                      <p
                        class="text-sm sm:px-2 text-primary-400 font-semibold xs:text-xxs"
                        :style="btnOutlineText"
                      >
                        + {{ lang["add_to_cart"][language] }}
                      </p>
                    </div>
                  </div>
                  <div v-if="!orderingEnabled">
                    <span
                      class="text-new-primary font-semibold text-sm mt-1 block xs:text-sm"
                      :style="listsText"
                      v-if="cupsItem.price > 0"
                      >{{ currency }}
                      {{ (Math.round(cupsItem.price * 100) / 100).toFixed(2) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-center mb-6">
              <button
                class="mx-auto text-white rounded-full px-8 p-2"
                :style="makeStyles(hasKiosk&&mainButtonRadius, paymentBtnBackground)"
                @click="
                  !hasKiosk
                    ? [$modal.show('cart-items'), $modal.hide('cups')]
                    : ''
                "
              >
                {{ lang["go_to_cart"][language] }}
              </button>
            </div>
          </div>
        </modal>

</template>
<script>
import { mapGetters } from 'vuex'
import lang from "../lang.js";

export default {
    name: "CupsModal",
    props: {
        cupsItem: {
            type: Array,
            require:true
        },
        itemBeingAdded: {
            require:true
        },
        disableAddButton: {
            type: Boolean,
            require:true
        }
    },
    data() {
        return {
            lang: lang,
        }
    },
    computed: {
        ...mapGetters([
            "language",
            "hasKiosk",
            "menu",
            "theme",
            "orderingEnabled",
            "buttonStack",
            "processBarIndex",
            "showTable",
            "showPayment",
            "showForm",
            "showTableManual",
            "processCurrentName",
            "upselling",
            "selectedMenuCategory",
            "currency",
        ]),
        ...mapGetters("Cart", [
            "cartItems",
            "tableManual",
            "items",
        ]),
        ...mapGetters("Theme", [
          "addButtonRadius",
            "text",
            "titleFont",
            "titleMain",
            "titleTextTransform",
            "btnOutlineText",
            "btnOutlineIcon",
            "buttonImgColors",
            "btnOutlineBorder",
            "mainButtonRadius",
            "btnDestructiveIcon",
            "btnOutlineActiveText",
            "btnOutlineBackground",
            "paymentBtnBackground",
            "btnOutlineActiveBorder",
            "btnOutlineActiveBackground",
        ]),
    }
    
}
</script>